import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  TextField,
  BtnPurpleTransparent32,
  BtnGreen32,
  SelectCustom
} from 'components/common/Elements/Elements';

import { postRequest } from 'utils/requests';

import classes from './BodyModalAlert.module.scss';

const options = [
  { value: 'email', label: 'E-mail' }
  // { value: 'telegram', label: 'Telegram' },
  // { value: 'slack', label: 'Slack' }
];

const BodyModalAlert = ({
  id,
  name,
  onCancel,
  submit,
  mixpanel,
  onOfNotif
}) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;
  const useremail = useUserState().user.email;

  const [deliveryType, setDeliveryType] = useState({
    value: 'email',
    label: 'E-mail'
  });

  const [mail, setMail] = useState('');

  useEffect(() => {
    setMail(useremail);
  }, [useremail]);

  const onChangeSelect = value => {
    setDeliveryType(value);
  };

  const onSubscribe = () => {
    const REQ_BODY = {
      name: name,
      group: id,
      alertType: 'new_articles',
      deliveryOption: deliveryType.value,
      deliveryOptionValue: mail
    };

    postRequest('/api/press-release-alertsettings/', REQ_BODY)
      .then(res => {
        onCancel(false);
        submit(res);
        onOfNotif('on', t('notif', 'SUBSCRIBE_OK', language), false, '2000');
      })
      .catch(err => {
        console.log(err);
        onCancel(false);
      });
  };

  return (
    <div className={classes.bodyModalAlert}>
      <p className={classes.discription}>
        {t('bodyModalAlert', 'RECEIVE_NOTIF_NEWS', language)}
      </p>
      <p className={classes.name}>{name}</p>
      <div className={classes.formBox}>
        <div className={classes.selectBox}>
          <SelectCustom
            selectTitle={t('bodyModalAlert', 'DELIVERY', language)}
            value={deliveryType}
            onChange={onChangeSelect}
            options={options}
          />
        </div>

        <TextField
          value={mail}
          labelText={t('bodyModalAlert', 'ADRESS', language)}
          type="text"
          onChange={e => {
            setMail(e.target.value);
          }}
          className={classes.email}
          boxShadow
          placeholder={t('bodyModalAlert', 'PLACEHOLDER_ADRESS', language)}
          required
        />
      </div>
      <div className={classes.buttonBox}>
        <BtnPurpleTransparent32
          onClick={() => {
            trackingEvent('cancel_receive_notif', mixpanel, username);
            onCancel();
          }}
          textButton={t('bodyModalAlert', 'CANCEL', language)}
          className={classes.btnCancel}
        />
        <BtnGreen32
          textButton={t('bodyModalAlert', 'SUBSCRIBE', language)}
          onClick={() => {
            trackingEvent('receive_notif_on', mixpanel, username);
            onSubscribe(id);
          }}
          className={classes.btnSubscribe}
          type="submit"
          disabled={mail.length > 0 ? false : true}
        />
      </div>
    </div>
  );
};

BodyModalAlert.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  mixpanel: PropTypes.object,
  onOfNotif: PropTypes.func
};

export default BodyModalAlert;
